// autopilot-ui-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'apu.confidence': '{pct} confidence',
  'apu.voucherLinked': 'Voucher linked: {name}',
  'apu.taskApproved': 'Task approved 🟣',
  'apu.approvalNeedsCompany': 'Approval requires you to be signed in with an active company.',
  'apu.theTaskApproved': 'The task has been approved 🟣',
  'apu.approveFailed': 'Could not approve the task.',
  'apu.agentChecksApproved': '{count} agent checks have been approved.',
  'apu.approveChecksFailed': 'Could not approve the agent checks.',
  'apu.updateProposalFailed': 'Could not update the proposal.',
  'apu.postponeFailed': 'Could not postpone the line.',
  'apu.linkVoucherFailed': 'Could not link the voucher.',
  'apu.linkedManually': 'Voucher linked manually',
});
